import React from 'react';

import AlertScreenResolution from 'components/alert/AlertScreenResolution';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';

import AlertComponent from 'components/alert/Alert';
import RouterComponent from 'router';
import themes from 'consts/theme';
import UserSessionDataHandler from 'auth/UserSessionsDataHandler';
import { setLanguage } from 'store/actions/language/language';
import { setTimezone } from 'store/actions/time/timezone';

class App extends React.Component {
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { dispatch } = this.props;
    const userSettingObject = UserSessionDataHandler.getUserSettingsObject();

    if (
      userSettingObject &&
      userSettingObject[UserSessionDataHandler.defaultLanguage]
    )
      dispatch(
        setLanguage(userSettingObject[UserSessionDataHandler.defaultLanguage])
      );
    else dispatch(setLanguage('en'));

    if (
      userSettingObject &&
      userSettingObject[UserSessionDataHandler.defaultTimezone]
    ) {
      dispatch(
        setTimezone(userSettingObject[UserSessionDataHandler.defaultTimezone])
      );
    } else {
      dispatch(setTimezone('Poland'));
    }
  }

  render() {
    return (
      <div className="App">
        <MuiThemeProvider
          theme={createTheme(
            themes[UserSessionDataHandler.getTheme() || 'light']
          )}
        >
          <AlertScreenResolution />
          <RouterComponent />
          <AlertComponent />
        </MuiThemeProvider>
      </div>
    );
  }
}

App.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default connect()(App);
